import React, { memo, useEffect, useState } from "react";
import cls from "classnames";
import { useT, useCtx, withRedux, WithReduxHocPropsType } from "@al/next/al-ex";
import { PriceTools, CountryCode } from "@al/base-lib";

import Iconfont from "~/components/ui/Iconfont";
import LineThroughPrice from "~/components/ui/LineThroughPrice";

import { SkuPriceType, PromotionGuideBarType, SkuInfoType } from "../../types";
import helper from "../../redux/helper";
import Stars from "../../components/Stars";

import styles from "./styles.scss";
import { formatSaleCount } from "./utils";

interface Props extends WithReduxHocPropsType {
  postFee: number | null;
  name: string;
  score: string | null;
  skuPrice: SkuPriceType | null;
  currentSku: SkuInfoType;
}

const ProductInfo: React.FC<Props> = (props) => {
  const t = useT();
  const ctx = useCtx();
  const currentSku = props.currentSku;
  const { promotion, couponPrice, crossedPrice, sellingPrice } = props.skuPrice || {};
  const [sales, setSales] = useState<string | number>();

  useEffect(() => {
    async function getSpuSales(): Promise<void> {
      const { success, data } = await ctx.store.dispatch(helper.actions.asyncGetSpuSales({ spuId: ctx.query.spuId }));
      success && data.spuSaleCount !== null && setSales(formatSaleCount(data.spuSaleCount));
    }
    getSpuSales();
  }, [ctx]);

  // 秒杀不展示 预告
  // const currentPromotionConfig = useMemo(
  //   () =>
  //     nextPromotion?.activityType &&
  //     nextPromotion.activityType === ActivityType.Limited &&
  //     promotionConfig[nextPromotion.activityType],
  //   [nextPromotion]
  // );

  return (
    <div className={styles.info}>
      {/* 价格透出逻辑 */}
      {!promotion || promotion.guideBarStyle === PromotionGuideBarType.None ? (
        <div className={cls(styles.price_box, couponPrice && styles.justify_center)}>
          {/* 有券后价，或者有折扣活动，价格显示红色 */}
          <span className={styles.price}>
            {PriceTools.formatPrice(
              ctx.locale.countryCode as CountryCode,
              sellingPrice || currentSku?.originalPrice,
              "price"
            )}
          </span>
          {/* 有活动且有券后价的时候，优先显示 券后价 */}
          {couponPrice ? (
            <span className={styles.coupon_price}>
              {PriceTools.formatPrice(ctx.locale.countryCode as CountryCode, couponPrice, "price")}&nbsp;
              {t("券后价")}
            </span>
          ) : (
            <>
              {crossedPrice && crossedPrice > 0 && (
                <LineThroughPrice className={styles.origin_price} value={Number(crossedPrice)} />
              )}
              {promotion?.discount && <span className={styles.discount}>-{promotion.discount}</span>}
            </>
          )}
        </div>
      ) : null}

      {/* 促销预告信息 */}
      {/* {currentPromotionConfig ? (
        <div className={styles.promotion}>
          <span className={styles.promotion_name}>
            <Iconfont className={styles.promotion_name_icon} name={currentPromotionConfig.icon} />{" "}
            <span>{t(currentPromotionConfig.name)}</span>
          </span>
          {nextPromotion?.beginTime ? (
            <>
              <span className={styles.promotion_down_time}>
                {dayjs(Number(nextPromotion?.beginTime)).format("DD. MMM, HH:mm")}
              </span>
              &nbsp;
              <span>{t("global:price", { value: nextPromotion?.activityPrice })}</span>
            </>
          ) : null}
        </div>
      ) : null} */}

      {/* 包邮标签 */}
      {props.postFee !== null && Number(props.postFee) === 0 ? (
        <div className={styles.label_box}>
          <span className={styles.tag_free_ship}>
            <Iconfont name="logistics" />
            <span className={styles.tag_free_ship_label}>{t("包邮")}</span>
          </span>
        </div>
      ) : null}

      {/* 商品名称 */}
      <div className={styles.name}>{props.name}</div>

      {/* 销量和评分 */}
      {sales || props.score ? (
        <div className={styles.count_rate_wrapper}>
          {/* 评分 */}
          {props.score ? (
            <>
              <span className={styles.score}>{props.score}</span>
              <Stars className={styles.rate} value={props.score} />
            </>
          ) : null}
          {/* 销量 */}
          {sales && (
            <div className={styles.count}>
              {sales} {t("销量")}
            </div>
          )}
        </div>
      ) : null}
    </div>
  );
};

export default withRedux((state) => ({
  score: state.static.spuScore,
  postFee: state.static.freightInfo?.freight,
  skuPrice: state.static.skuPrice,
  currentSku: state.static.currentSku,
}))(memo<Props>(ProductInfo));
